import apiClient from "@/api/apiClient";

// Acties voor de dienst-aanvraagflow: aanvraag indienen, HR-beoordeling,
// versturen door de aanvrager en datums doorgeven door de dienstverlener.
// Alle endpoints zijn publiek (magic links), dus er is geen lokale state nodig.
const actions = {
    // Publieke lijst van schoolbesturen voor de dropdown in het aanvraagformulier.
    fetchSchoolbesturen() {
        return apiClient.get('/schoolbesturen').then(response => response.data);
    },

    // Dien een nieuwe aanvraag in voor de dienstverlener met de gegeven uuid.
    submitRequest(_, { uuid, data }) {
        const formData = new FormData();
        formData.append('organisation', uuid);
        Object.keys(data).forEach(key => {
            if (data[key] !== null && data[key] !== undefined && data[key] !== '') {
                formData.append(key, data[key]);
            }
        });

        return apiClient.post('/aanvragen', formData).then(response => response.data);
    },

    // HR-beoordeling (magic link).
    fetchReview(_, { token }) {
        return apiClient.get('/aanvragen/beoordelen/' + token).then(response => response.data);
    },
    // Bij goedkeuren gaan de facturatiegegevens (rekeninghouder, IBAN, referentie) mee.
    submitReview(_, { token, status, invoice }) {
        const formData = new FormData();
        formData.append('status', status);

        if (invoice) {
            if (invoice.accountHolder) formData.append('invoiceAccountHolder', invoice.accountHolder);
            if (invoice.iban) formData.append('invoiceIban', invoice.iban);
            if (invoice.reference) formData.append('invoiceReference', invoice.reference);
        }

        return apiClient.post('/aanvragen/beoordelen/' + token, formData).then(response => response.data);
    },

    // Versturen door de aanvrager (magic link).
    fetchSubmit(_, { token }) {
        return apiClient.get('/aanvragen/versturen/' + token).then(response => response.data);
    },
    confirmSubmit(_, { token }) {
        return apiClient.post('/aanvragen/versturen/' + token).then(response => response.data);
    },

    // Datums doorgeven door de dienstverlener (magic link).
    fetchDates(_, { token }) {
        return apiClient.get('/aanvragen/datums/' + token).then(response => response.data);
    },
    // De einddatum is optioneel en kan later via dezelfde link worden ingevuld of gewijzigd;
    // de startdatum wordt dan niet meer meegestuurd.
    submitDates(_, { token, expectedStartDate, expectedEndDate }) {
        const formData = new FormData();
        if (expectedStartDate) formData.append('expectedStartDate', expectedStartDate);
        if (expectedEndDate) formData.append('expectedEndDate', expectedEndDate);

        return apiClient.post('/aanvragen/datums/' + token, formData).then(response => response.data);
    },

    // Evaluatie door de aanvrager, een week na de einddatum (magic link).
    fetchEvaluation(_, { token }) {
        return apiClient.get('/aanvragen/evalueren/' + token).then(response => response.data);
    },
    // Vragen 1 t/m 7 zijn verplicht, de tip (vraag 8) is optioneel.
    submitEvaluation(_, { token, needsFit, quality, professionalism, outcomes, outcomeOther, mainResult, appreciated, rating, tip }) {
        const formData = new FormData();
        formData.append('needsFit', needsFit);
        formData.append('quality', quality);
        formData.append('professionalism', professionalism);
        (outcomes || []).forEach(outcome => formData.append('outcomes[]', outcome));
        formData.append('mainResult', mainResult);
        formData.append('appreciated', appreciated);
        formData.append('rating', rating);
        if (outcomeOther) {
            formData.append('outcomeOther', outcomeOther);
        }
        if (tip) {
            formData.append('tip', tip);
        }

        return apiClient.post('/aanvragen/evalueren/' + token, formData).then(response => response.data);
    },
}

export default {
    actions,
    namespaced: true
}
